import { LogItemLayout, LogItemProps } from '../LogItemLayout';
import { useTitle } from './useTitle';
import { useDetail } from './useDetail';

export const LogItemRound = (props: LogItemProps) => {
  const { data } = props;

  const title = useTitle(data);
  const detail = useDetail(data);

  return <LogItemLayout {...props} title={title} before={detail?.before} after={detail?.after} />;
};
